import React from "react";
import { HashLink } from "react-router-hash-link";

// Images
import nutrigener_logo from "../../images/logos/nutrigener-logo-crest.png";
import sportgener_logo from "../../images/logos/sportgener-logo-crest.png";
import fundgener_logo from "../../images/logos/fundgener-logo-crest.png";
import mindgener_logo from "../../images/logos/mindgener-logo-crest.png";
import dancezonea_logo from "../../images/logos/dancezonea-logo-crest.png";
import soon_blue from "../../images/logos/soon-blue.png";
import soon_orange from "../../images/logos/soon-orange.png";
import nutrigener_bg from "../../images/platforms/nutrigener-bg.png";
import sportgener_bg from "../../images/platforms/sportgener-bg.png";
import dancezonea_bg from "../../images/platforms/dancezonea-bg.png";
import fundgener_bg from "../../images/platforms/fundgener-bg.png";
import mindgener_bg from "../../images/platforms/mindgener-bg.png";

// Stylesheets
import "./Platforms.scss";

const Platforms = () => {
    return (
        <section className="platforms" id="platforms">
            <span className="platforms-eyebrow">OUR ECOSYSTEM</span>
<h1>PLATFORMS</h1>
<p className="platforms-intro">Independent companies. One shared vision.</p>
            <div className="wrapper">
                <div
  className="platform platform-nutrigener"
  style={{ backgroundImage: `url(${nutrigener_bg})` }}
>
    <div className="platform-overlay"></div>

    <div className="platform-content">
        <img
            className="platform-logo"
            src={nutrigener_logo}
            alt="NutriGeneR"
        />

        <h2>NUTRIGENER</h2>

        <h3>Health, Nutrition & Longevity</h3>

        <div className="platform-line"></div>

        <p>
            Health and nutrition solutions designed to improve human
            wellbeing and performance through science and nature.
        </p>

        <a
            className="platform-link"
            href="https://www.viewgener.com"
            target="_blank"
            rel="noopener noreferrer"
        >
            EXPLORE PLATFORM <span className="platform-arrow">→</span>
        </a>
    </div>
</div>
                <div
  className="platform platform-sportgener"
  style={{ backgroundImage: `url(${sportgener_bg})` }}
>
    <div className="platform-overlay"></div>

    <div className="platform-content">
        <img
            className="platform-logo"
            src={sportgener_logo}
            alt="SportGeneR"
        />

        <h2>SPORTGENER</h2>

        <h3>Sports, Talent & Management</h3>

        <div className="platform-line"></div>

        <p>
            Building talent, managing careers and creating opportunities
across the world of sport.
        </p>

        <a
            className="platform-link"
            href="https://www.viewgener.com"
            target="_blank"
            rel="noopener noreferrer"
        >
            EXPLORE PLATFORM <span className="platform-arrow">→</span>
        </a>
    </div>
</div>
<div
  className="platform platform-dancezonea"
  style={{ backgroundImage: `url(${dancezonea_bg})` }}
>
    <div className="platform-overlay"></div>

    <div className="platform-content">
        <img
            className="platform-logo"
            src={dancezonea_logo}
            alt="DanceZonea Productions"
        />

        <h2>DANCEZONEA</h2>

        <h3>Dance Lessons, Entertainment & Events</h3>

        <div className="platform-line"></div>

        <p>
            <p>
            Connecting people through dance, entertainment and memorable events.
</p>
        </p>

        <a
            className="platform-link"
            href="https://www.dancezonea.com"
            target="_blank"
            rel="noopener noreferrer"
        >
            EXPLORE PLATFORM <span className="platform-arrow">→</span>
        </a>
    </div>
</div>
<div
  className="platform platform-fundgener"
  style={{ backgroundImage: `url(${fundgener_bg})` }}
>
    <div className="platform-overlay"></div>

    <div className="platform-content">
        <img
            className="platform-logo"
            src={fundgener_logo}
            alt="FundGeneR"
        />

        <h2>FUNDGENER</h2>

        <h3>Investment, Capital & Growth</h3>

        <div className="platform-line"></div>

        <p>
            Investment and financial solutions designed to support
            businesses, opportunities and long-term growth.
        </p>

        <a
            className="platform-link"
            href="https://www.viewgener.com"
            target="_blank"
            rel="noopener noreferrer"
        >
            EXPLORE PLATFORM <span className="platform-arrow">→</span>
        </a>
    </div>
 </div>
<div
  className="platform platform-mindgener"
  style={{ backgroundImage: `url(${mindgener_bg})` }}
>
    <div className="platform-overlay"></div>

    <div className="platform-content">
        <img
            className="platform-logo"
            src={mindgener_logo}
            alt="MindGeneR"
        />

        <h2>MINDGENER</h2>

        <h3>Mindset, Personal Development & Holistic Growth</h3>

        <div className="platform-line"></div>

        <p>
  Knowledge and tools to strengthen mindset, self-image and personal development,
  exploring how holistic growth connects with financial wellbeing.
</p>

        <a
            className="platform-link"
            href="https://www.viewgener.com"
            target="_blank"
            rel="noopener noreferrer"
        >
            EXPLORE PLATFORM <span className="platform-arrow">→</span>
        </a>
    </div>
</div>   
     
            </div>
            <HashLink to="#signin">
                <button>SIGN IN</button>
            </HashLink>
        </section>
    );
};

export default Platforms;